import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { copyToClipboard } from '@mwe/utils';
import { catchError, of, tap } from 'rxjs';
import { delay } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-clipboard-copy-button',
  templateUrl: './clipboard-copy-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class ClipboardCopyButtonComponent {
  copyData = input<string>();
  customCopyText = input<string>('shared.clipboardCopy.copy');
  customCopySuccessText = input<string>('shared.clipboardCopy.copySuccess');
  copySuccessFull = signal(false);

  copyText(): void {
    copyToClipboard(this.copyData())
      .pipe(
        tap(() => this.copySuccessFull.set(true)),
        delay(2000),
        tap(() => this.copySuccessFull.set(false)),
        catchError(() => {
          this.copySuccessFull.set(false);
          return of(null);
        }),
      )
      .subscribe();
  }
}
